// src/config.js
const config = {
    // API_BASE_URL: "https://bluerock.live/api.php?table="
    // API_BASE_URL: "https://papertrade.co.in/api.php?table=",
    API_BASE_URL: "https://suryanx.live/api_rfs.php?table=",
    APP_BASE_URL: "https://suryanx.live/"
  };
  
  export default config;
  